import { Team, AwayTeam } from './Team';
import { useEffect } from 'react';

const Game = ({ game, click, picks }) => {

    const date = new Date(game.date);
    const teams = game.competitions[0].competitors;

    const formattedDate = date.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', timeZone: 'America/New_York' });
    const formattedTime = date.toLocaleTimeString('en-US', {hour: 'numeric', minute: 'numeric', hour12: true, timeZone: 'America/New_York' });

    return (
        <div className="matchup-container">
            <div className="date">
                <h4>{formattedDate}</h4>
                <h5>{formattedTime}</h5>
            </div>

            <div className="teams">
                <Team team={teams[0]} matchup={game.id} type="home" click={click} picks={picks} />
                <div className="box-score"></div>
                <Team team={teams[1]} matchup={game.id} type="away" click={click} picks={picks} />
            </div>
        </div>
    );
};

export default Game;
